import { useState, useEffect, useCallback, useMemo } from "react"
import { useUser } from "../utils/UserContext";
import { Link } from "react-router-dom";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faArrowUpRightFromSquare } from '@fortawesome/free-solid-svg-icons'
import Select from "react-select";
import { getCurrencySymbol, formatCurrency, getRate } from '../utils/currencyUtils';
import Slider from '@mui/material/Slider';
import Box from '@mui/material/Box';

const marks = [
  {
    value: 0,
    label: '0',
  },
  {
    value: 10,
    label: '10',
  },
  {
    value: 20,
    label: '20',
  },
  {
    value: 30,
    label: '30',
  },
  {
    value: 40,
    label: '40',
  },
    {
    value: 50,
    label: '50',
  },
  {
    value: 60,
    label: '60',
  },
  {
    value: 70,
    label: '70',
  },
  {
    value: 80,
    label: '80',
  },
  {
    value: 100,
    label: '100',
  },
];
function valuetext(value) {
  return `${value}`;
}

function LoanCalculator() {
    const { user } = useUser();
    const [rate, setRate] = useState(1);
    const currencyCode = user?.currency;
    useEffect(() => {
        let isMounted = true;
        const fetchRate = async () => {
        const r = await getRate(currencyCode);
        if (isMounted) setRate(r);
        };
        fetchRate();
        return () => { isMounted = false; };
    }, [currencyCode]);
    const [loanOffer, setLoanOffer] = useState([]);
    useEffect(() => {
        fetch(`${process.env.REACT_APP_API_URL}controller/fetch.controller.php`, {
        credentials: "include",
        method: "POST",
        headers: {
            "Content-Type": "application/json"
        },
        body: JSON.stringify({ fetchoffer: true })
        })
        .then(response => response.json())
        .then(data => {
        if (data.status === "success") {
            const Offers = data.offers;
            const allOffers = [];
            Offers.forEach(loan => {
                allOffers.push({
                    value: loan.loan_id,
                    label: <>{loan.title}</>,
                    min: loan.min,
                    max: loan.max,
                    rate: loan.rate,
                    duration: loan.duration,
                    period: loan.period,
                });
            });
            setLoanOffer(allOffers);
        }
        })
        .catch(err => {
        })
    }, [user]);
    const darkThemeStyles = {
        control: (styles) => ({
        ...styles,
        backgroundColor: "#151719",
        border: "none",
        color: "#fff",
        }),
        menu: (styles) => ({
        ...styles,
        backgroundColor: "#151719",
        }),
        option: (styles, { isFocused, isSelected }) => ({
        ...styles,
        backgroundColor: isSelected ? "rgb(30, 33, 36)" : isFocused ? "rgb(30, 33, 36)" : "#151719",
        color: "#fff",
        }),
        singleValue: (styles) => ({
        ...styles,
        color: "#fff",
        }),
    };
    const darkThemeStyles1 = {
        control: (styles) => ({
        ...styles,
        backgroundColor: "rgb(30, 33, 36)",
        border: "none",
        color: "#fff",
        fontWeight: '600',
        }),
        menu: (styles) => ({
        ...styles,
        backgroundColor: "rgb(30, 33, 36)",
        fontWeight: '600',
        }),
        option: (styles, { isFocused, isSelected }) => ({
        ...styles,
        backgroundColor: isSelected ? "#151719" : isFocused ? "#151719" : "rgb(30, 33, 36)",
        color: "#fff",
        fontWeight: '600',
        }),
        singleValue: (styles) => ({
        ...styles,
        color: "#fff",
        fontWeight: '600',
        }),
    };
    const [error, setError] = useState(false);
    const [error1, setError1] = useState(false);
    const [assethistory, setAssethistory] = useState([]);
    const [crypto, setCrypto] = useState([]);
    const [fiat, setFiat] = useState([]);
    const [stock, setStock] = useState([]);
    const [wallet, setWallet] = useState([]);
    const durationList = [
        {
        "value": 50,
        "label": (<>50 Days</>)
        },
        {
        "value": 30,
        "label": (<>30 Days</>)
        },
        {
        "value": 60,
        "label": (<>60 Days</>)
        },
        {
        "value": 180,
        "label": (<>180 Days</>)
        },
        {
        "value": 365,
        "label": (<>1 Year</>)
        }
    ];
    const assetsData = [
        {
        "symbol": "BTC",
        "name": "Bitcoin",
        "id": 1,
        "type": "crypto",
        "image": "https://s2.coinmarketcap.com/static/img/coins/64x64/1.png",
        "value": "BTC",
        "label": (<><img src="https://s2.coinmarketcap.com/static/img/coins/64x64/1.png" alt="BTC" width={20} /> BTC</>)
        },
        {
        "symbol": "ETH",
        "name": "Ethereum",
        "id": 1027,
        "type": "crypto",
        "image": "https://s2.coinmarketcap.com/static/img/coins/64x64/1027.png",
        "value": "ETH",
        "label": (<><img src="https://s2.coinmarketcap.com/static/img/coins/64x64/1027.png" alt="ETH" width={20} /> ETH</>)
        },
        {
        "symbol": "LTC",
        "name": "Litecoin",
        "id": 2,
        "type": "crypto",
        "image": "https://s2.coinmarketcap.com/static/img/coins/64x64/2.png",
        "value": "LTC",
        "label": (<><img src="https://s2.coinmarketcap.com/static/img/coins/64x64/2.png" alt="LTC" width={20} /> LTC</>)
        },
        {
        "symbol": "USD",
        "name": "US Dollar",
        "type": "fiat",
        "image": "https://flagcdn.com/w40/us.png",
        "value": "USD",
        "label": (<><img src="https://flagcdn.com/w40/us.png" alt="USD" width={20} /> USD</>)
        },
        {
        "symbol": "GBP",
        "name": "British Pound",
        "type": "fiat",
        "image": "https://flagcdn.com/w40/gb.png",
        "value": "GBP",
        "label": (<><img src="https://flagcdn.com/w40/gb.png" alt="GBP" width={20} /> GBP</>)
        },
        {
        "symbol": "EURO",
        "name": "Euro",
        "type": "fiat",
        "image": "https://flagcdn.com/w40/eu.png",
        "value": "EURO",
        "label": (<><img src="https://flagcdn.com/w40/eu.png" alt="EURO" width={20} /> EURO</>)
        },
        {
        "symbol": "USDT",
        "name": "Tether",
        "id": 825,
        "type": "crypto",
        "image": "https://s2.coinmarketcap.com/static/img/coins/64x64/825.png",
        "value": "USDT",
        "label": (<><img src="https://s2.coinmarketcap.com/static/img/coins/64x64/825.png" alt="USDT" width={20} /> USDT</>)
        },
        {
        "symbol": "USDC",
        "name": "USD Coin",
        "id": 3408,
        "type": "crypto",
        "image": "https://s2.coinmarketcap.com/static/img/coins/64x64/3408.png",
        "value": "USDC",
        "label": (<><img src="https://s2.coinmarketcap.com/static/img/coins/64x64/3408.png" alt="USDC" width={20} /> USDC</>)
        },
        {
        "symbol": "BNB",
        "name": "BNB",
        "id": 1839,
        "type": "crypto",
        "image": "https://s2.coinmarketcap.com/static/img/coins/64x64/1839.png",
        "value": "BNB",
        "label": (<><img src="https://s2.coinmarketcap.com/static/img/coins/64x64/1839.png" alt="BNB" width={20} /> BNB</>)
        },
        {
        "symbol": "BCH",
        "name": "Bitcoin Cash",
        "id": 1831,
        "type": "crypto",
        "image": "https://s2.coinmarketcap.com/static/img/coins/64x64/1831.png",
        "value": "BCH",
        "label": (<><img src="https://s2.coinmarketcap.com/static/img/coins/64x64/1831.png" alt="BCH" width={20} /> BCH</>)
        },
        {
        "symbol": "XRP",
        "name": "XRP",
        "id": 52,
        "type": "crypto",
        "image": "https://s2.coinmarketcap.com/static/img/coins/64x64/52.png",
        "value": "XRP",
        "label": (<><img src="https://s2.coinmarketcap.com/static/img/coins/64x64/52.png" alt="XRP" width={20} /> XRP</>)
        },
        {
        "symbol": "XLM",
        "name": "Stellar",
        "id": 512,
        "type": "crypto",
        "image": "https://s2.coinmarketcap.com/static/img/coins/64x64/512.png",
        "value": "XLM",
        "label": (<><img src="https://s2.coinmarketcap.com/static/img/coins/64x64/512.png" alt="XLM" width={20} /> XLM</>)
        },
        {
        "symbol": "DOGE",
        "name": "Dogecoin",
        "id": 74,
        "type": "crypto",
        "image": "https://s2.coinmarketcap.com/static/img/coins/64x64/74.png",
        "value": "DOGE",
        "label": (<><img src="https://s2.coinmarketcap.com/static/img/coins/64x64/74.png" alt="DOGE" width={20} /> DOGE</>)
        },
        {
        "symbol": "TRX",
        "name": "TRON",
        "id": 1958,
        "type": "crypto",
        "image": "https://s2.coinmarketcap.com/static/img/coins/64x64/1958.png",
        "value": "TRX",
        "label": (<><img src="https://s2.coinmarketcap.com/static/img/coins/64x64/1958.png" alt="TRX" width={20} /> TRX</>)
        },
        {
        "symbol": "SOL",
        "name": "Solana",
        "id": 5426,
        "type": "crypto",
        "image": "https://s2.coinmarketcap.com/static/img/coins/64x64/5426.png",
        "value": "SOL",
        "label": (<><img src="https://s2.coinmarketcap.com/static/img/coins/64x64/5426.png" alt="SOL" width={20} /> SOL</>)
        }
    ];
    useEffect(() => {
        fetch(`${process.env.REACT_APP_API_URL}controller/fetch.controller.php`, {
        credentials: "include",
        method: "POST",
        headers: {
            "Content-Type": "application/json"
        },
        body: JSON.stringify({ fetchwallet: true })
        })
        .then(response => response.json())
        .then(data => {
        if (data.status === "success") {
            setWallet(data.wallet);
        }
        })
        .catch(err => {
        
        })
    }, [user]);
    useEffect(() => {
        fetch(`/coin_list.txt`)
        .then((res) => res.json())
        .then((data) => {
        var coinList = data.data;
        const updatedData = coinList.map((coin, index) => ({
            id: index + 1,
            logo: `https://s2.coinmarketcap.com/static/img/coins/64x64/${coin.id}.png`,
            name: coin.name,
            type: 'crypto',
            symbol: coin.symbol,
            price: Number(coin.quote.USD.price.toFixed(2)),
            amount: 0,
        }));
        setCrypto(updatedData);
        })
        .catch((err) => console.error("Error loading coin list:", err));
    }, []);
    useEffect(() => {
        fetch(`/stock_list.txt`)
        .then((res) => res.json())
        .then((data) => {
        const stockList = Object.values(data);
        const updatedData = stockList.map((stock, index) => ({
            id: index + 1,
            logo: `https://images.financialmodelingprep.com/symbol/${stock.symbol}.png`,
            name: stock.name,
            type: 'stock',
            symbol: stock.symbol,
            price: Number(stock.price.toFixed(2)),
            amount: 0,
        }));
        setStock(updatedData);
        })
        .catch((err) => console.error("Error loading coin list:", err));
    }, []);
    useEffect(() => {   
        fetch(`/fiat_list.txt`)
        .then((res) => res.json())
        .then((data) => {
            const wantedCurrencies = {
            AUD: 'Australian Dollar',
            CAD: 'Canadian Dollar',
            CHF: 'Swiss Franc',
            CNY: 'Chinese Yuan',
            EUR: 'Euro',
            GBP: 'British Pound',
            INR: 'Indian Rupee',
            JPY: 'Japanese Yen',
            RUB: 'Russian Ruble',
            USD: 'US Dollar',
            ZAR: 'South African Rand'
            };
            const fiatList = Object.entries(data)
            .filter(([code]) => wantedCurrencies.hasOwnProperty(code))
            .map(([code, value], index) => ({
                id: index + 1,
                symbol: code,
                name: wantedCurrencies[code],
                price: Number(value),
                type: 'fiat',
                logo: `https://flagcdn.com/w40/${code.slice(0, 2).toLowerCase()}.png`,
                amount: 0,
            }));
            
            setFiat(fiatList);
        })
        .catch((err) => console.error("Error loading coin list:", err));
    }, []);
    useEffect(() => {
        if (!crypto.length && !fiat.length && !stock.length) return;
        const walletMap = wallet.reduce((acc, item) => {
        const key = item.coinName?.trim().toLowerCase();
        acc[key] = parseFloat(item.balance) || 0;
        return acc;
        }, {});
        const applyWalletBalance = (list, categoryTotal) => {
        let categorySum = 0;
        const result = list.map(item => {
            const key = item.name?.trim().toLowerCase();
            const matchedBalance = walletMap[key];
            const amount = matchedBalance || 0;
            const value = amount * item.price;
            categorySum += value;
            return {
            ...item,
            amount: matchedBalance || 0
            };
        });
        return { result, categorySum };
        };
        const { result: cryptoWithBalance } = applyWalletBalance(crypto);
        const { result: fiatWithBalance } = applyWalletBalance(fiat);
        const { result: stockWithBalance } = applyWalletBalance(stock);
        const merged = [
        ...cryptoWithBalance,
        ...fiatWithBalance,
        ...stockWithBalance
        ];
        const sorted = merged.sort((a, b) => {
        if (b.amount > 0 && a.amount === 0) return 1;
        if (a.amount > 0 && b.amount === 0) return -1;
        return a.name.localeCompare(b.name);
        });
        const allAssets = [];
        sorted.forEach(coin => {
        allAssets.push({
            value: coin.name,
            label: <><img src={coin.logo} alt={coin.symbol} width="20" /> {coin.symbol}</>,
            id: coin.id,
            logo: coin.logo,
            name: coin.name,
            symbol: coin.symbol,
            type: coin.type,
            price: coin.price,
            amount: coin.amount
        });
        });
        setAssethistory(allAssets);
    }, [crypto, fiat, stock, wallet]);
    //FORM DATA
    const [loanID, setLoanID] = useState();
    const [min, setMin] = useState(0);
    const [max, setMax] = useState(0);
    const [lrate, setLrate] = useState();
    const [duration, setDuration] = useState();
    const [period, setPeriod] = useState();
    const [casset, setCasset] = useState("Bitcoin");
    const [collateral, setCollateral] = useState(0);
    const [collat, setCollat] = useState("BTC");
    const [coinBal, setCoinBal] = useState(0);
    const [cprice, setCprice] = useState();
    const [disable, setDisable] = useState(true);
    const [loanasset, setLoanAsset] = useState();
    const [loan, setLoan] = useState();
    const [loanUsd, setLoanUsd] = useState();
    const [price, setPrice] = useState(0);
    const [ltv, setLtv] = useState(30);
    useEffect(() => {
        const isCollateralValid = loanID === "HML9944345545544" ? true : Boolean(collateral);
        if ( loanID && casset && isCollateralValid && collat && loanasset && loan && loanUsd && ltv && cprice && price) {
            setDisable(false);
        } else {
            setDisable(true);
        }
    }, [loanID, casset, collateral, collat, loanasset, loan, loanUsd, ltv, cprice, price]);
    //END OF FORM DATA
    const symbolToAmountMap = useMemo(() => {
        const map = {};
        for (const item of assethistory) {
            if (!item || !item.symbol) continue;
            const key = item.symbol.trim().toLowerCase();
            map[key] = item.amount || 0;
        }
        return map;
    }, [assethistory]);
    const getBalanceBySymbol = useCallback((symbol) => {
        if (!symbol) {
            setCoinBal(0);
            return;
        }
        const key = symbol.trim().toLowerCase();
        const balance = symbolToAmountMap[key] || 0;
        setCoinBal(balance);
    }, [symbolToAmountMap]);
    useEffect(() => {
        getBalanceBySymbol(collat);
    }, [collat, getBalanceBySymbol])
    function validateCollateral(value){
        setCollateral(value);
        const asset = assethistory.find((opt) => opt.symbol === collat);
        setCprice(asset.price);
        if(loanID != "HML9944345545544"){
            if(Number(value) > Number(coinBal) || Number(coinBal) === 0 || Number(value) === 0){
            setError(true);
            }else{
            setError(false);
            }
        }else{
            setError(false);
        }
    }
    function updateLoan(e){
        setLoanID(e.value);
        setMin(e.min);
        setMax(e.max);
        setLrate(e.rate);
        setDuration(e.duration);
        setPeriod(e.period);
        if(e.value == "HML9944345545544"){
            setCollateral(0)
            setError(false)
        }else{
            setCollateral('');
        }
    }
    const convertToDays = (period, qty) => {
        const map = { y: 356, m: 30, w: 7, d: 1 };
        const base = map[String(period)] || 'Year';
        return (qty * base);
    };
    function validateLoan(value){
        setLoan(value);
        if(loanasset){
            const asset = assethistory.find((opt) => opt.value === loanasset);
            setPrice(asset.price);
            const AmntUSD = asset ? Number(asset.price) * value : 0;
            setLoanUsd(AmntUSD);
            if(min && max){
                if(AmntUSD > Number(max) || AmntUSD < Number(min)){
                    setError1(true);
                }else{
                    setError1(false);
                }
            }
        }
    }

    return (
        <div className="row">
            <div className="col-lg-7">
                <div className="mycard p-3">
                    <p className="mb-2" style={{fontSize:'14px',fontWeight:'900'}}>Loan Calculator</p>
                    <div className="row">
                        <div className="col-md-6 mb-2">
                            <label className="fw-semibold mb-1" style={{fontSize: '12px'}}>Loan Type</label>
                            <Select 
                                options={loanOffer} 
                                value={loanOffer.find((opt) => opt.value === loanID)}
                                onChange={(e) => {
                                    updateLoan(e)
                                }}
                                styles={darkThemeStyles}
                            />
                        </div>
                        <div className="col-md-6 mb-2">
                            <div className="d-flex align-items-center justify-content-between mb-1">
                                <label className="fw-semibold mb-1" style={{fontSize: '12px'}}>Collateral</label>
                                <p className="mb-0 text-secondary" style={{fontSize:'12px'}}>Bal: {parseFloat(coinBal).toFixed(4)} {collat}</p>
                            </div>
                            <div className={`d-flex align-items-between rounded-1 ps-2 justify-content-between shrinkSelect ${error ? 'input-error' : ''}`} style={{padding:'4px',backgroundColor:'#151719'}}>
                                <input 
                                    type="text" 
                                    placeholder="0.0000" 
                                    className="inputNone"
                                    value={collateral}
                                    onChange={(e) => {validateCollateral(e.target.value);}}
                                    readOnly={loanID === "HML9944345545544"}
                                />
                                <Select
                                    options={assetsData} 
                                    value={assetsData.find((opt) => opt.value === collat)}
                                    onChange={(selectedOption) => {
                                    setCasset(selectedOption.name);
                                    setCollat(selectedOption.symbol);
                                    getBalanceBySymbol(selectedOption.symbol);
                                    }}
                                    isSearchable
                                    styles={darkThemeStyles1}
                                />
                            </div>
                            {error && (
                            <p className="mb-0 text-danger mt-1" style={{fontSize:'10px',lineHeight:'100%'}}>Your {collat} balance is below the amount you have selected.</p>
                            )}
                        </div>
                        <div className="co-12">
                            <label className="fw-semibold mb-1" style={{fontSize: '12px'}}>Period (days)</label>
                            <Box sx={{ width: '100%', paddingLeft:'10px', paddingRight:'10px', marginTop: '26px' }}>
                            <Slider
                                aria-label="Always visible"
                                defaultValue={ltv}
                                value={ltv}
                                onChange={(event, newValue) => setLtv(newValue)}
                                getAriaValueText={valuetext}
                                step={10}
                                marks={marks}
                                valueLabelDisplay="on"
                                sx={{
                                color: "#ff6b35",
                                "& .MuiSlider-thumb": {
                                    backgroundColor: "#ff6b35", 
                                    border: "5px solid #ff6b35",
                                    borderRadius: '3px'
                                },
                                "& .MuiSlider-thumb:before": {
                                    boxShadow: 'none'
                                },
                                "& .MuiSlider-thumb:hover, & .MuiSlider-thumb.Mui-focusVisible": {
                                    boxShadow: "0px 0px 0px 8px rgba(248, 156, 123, 0.2)",
                                },
                                "& .MuiSlider-track": {
                                    backgroundColor: "#ff6b35",
                                    height: '10px'
                                },
                                "& .MuiSlider-rail": {
                                    backgroundColor: "#ffffff80",
                                    opacity: 1,
                                    height: '10px'
                                },
                                "& .MuiSlider-valueLabel": {
                                    backgroundColor: "#ff6b35",
                                    color: "#fff",
                                    borderRadius: "4px",
                                },
                                "& .MuiSlider-mark": {
                                    backgroundColor: "#000000ff",
                                    width: '5px',
                                    height: '8px',
                                    borderRadius: '4px'
                                },
                                "& .MuiSlider-markActive": {
                                    backgroundColor: "#ff6b35",
                                },
                                "& .MuiSlider-markLabel": {
                                    color: "#ffffffff",
                                    fontWeight: '600'
                                },
                                "& .MuiSlider-markLabelActive": {
                                    color: "#ff6b35",
                                },
                                }}
                            />
                            </Box>
                        </div>
                        <div className="col-md-6 mb-2">
                            <label className="fw-semibold mb-1" style={{fontSize: '12px'}}>Loan Term</label>
                            <Select 
                                options={durationList} 
                                value={durationList.find((opt) => opt.value === ltv)}
                                onChange={(e) => {setLtv(e.value);}}
                                styles={darkThemeStyles}
                            />
                        </div>
                        <div className="col-md-6 mb-2">
                            <label className="fw-semibold mb-1" style={{fontSize: '12px'}}>Loan Amount</label>
                            <div className={`d-flex align-items-between rounded-1 ps-2 justify-content-between shrinkSelect ${error1 ? 'input-error' : ''}`} style={{padding:'4px',backgroundColor:'#151719'}}>
                                <input 
                                    type="text" 
                                    placeholder="0.0000" 
                                    className="inputNone"
                                    value={loan}
                                    onChange={(e) => {validateLoan(e.target.value);}}
                                />
                                <Select
                                    options={assethistory} 
                                    value={assethistory.find((opt) => opt.value === loanasset)}
                                    onChange={(selectedOption) => {setLoanAsset(selectedOption.value);}}
                                    isSearchable
                                    styles={darkThemeStyles1}
                                    className="w-full"
                                />
                            </div>
                            {error1 && (
                                <p className="mb-0 text-danger mt-1" style={{fontSize:'10px'}}>Loan amount must be between {getCurrencySymbol(user?.currency)}{formatCurrency(min * rate)} and {getCurrencySymbol(user?.currency)}{formatCurrency(max * rate)}</p>
                            )}
                        </div>
                    </div>
                </div>
            </div>
            <div className="col-lg-5">
                <div className="mycard p-3 mt-2 mt-lg-0">
                    <div className="d-flex align-items-center justify-content-between mb-3">
                        <p className="mb-0" style={{fontSize:'14px',fontWeight:'900'}}>Total Loan Repayment</p>
                        <p className="mb-0 fs-4 text-prime" style={{fontWeight:'900'}}>{formatCurrency((loanUsd + (((ltv/convertToDays(period, duration) * lrate) / 100) * loanUsd)) * rate)}{getCurrencySymbol(user?.currency)}</p>
                    </div>
                    <div className="d-flex align-items-center justify-content-between mb-1">
                        <p className="mb-0 fw-bold" style={{fontSize:'14px'}}>Interest Rate</p>
                        <p className="mb-0" style={{fontSize:'14px'}}>{(ltv && period && duration && lrate ? ltv/convertToDays(period, duration) * lrate : 0).toFixed(2)}%</p>
                    </div>
                    <div className="d-flex align-items-center justify-content-between mb-1">
                        <p className="mb-0 text-secondary" style={{fontSize:'14px'}}>Loan Term</p>
                        <p className="mb-0" style={{fontSize:'14px'}}>{ltv} days</p>
                    </div>
                    <div className="d-flex align-items-center justify-content-between mb-1">
                        <p className="mb-0 text-secondary" style={{fontSize:'14px'}}>Collateral Amount</p>
                        <p className="mb-0" style={{fontSize:'14px'}}>{Number(collateral ? collateral : 0).toFixed(6)} {collat}</p>
                    </div>
                    <div className="d-flex align-items-center justify-content-between mb-1">
                        <p className="mb-0 text-secondary" style={{fontSize:'14px'}}>Collateral Rate ({user?.currency})</p>
                        <p className="mb-0" style={{fontSize:'14px'}}>{formatCurrency(collateral && cprice ? collateral * cprice : 0)} {getCurrencySymbol(user?.currency)}</p>
                    </div>
                    <hr style={{borderColor:'#ff6b35'}}/>
                    <div className="d-flex align-items-center justify-content-between mb-1">
                        <p className="mb-0 text-secondary" style={{fontSize:'14px'}}>Loan Amount</p>
                        <p className="mb-0" style={{fontSize:'14px'}}>{Number(loan ? loan : 0)} {loanasset}</p>
                    </div>
                    <div className="d-flex align-items-center justify-content-between mb-1">
                        <p className="mb-0 text-secondary" style={{fontSize:'14px'}}>Loan Amount ({user?.currency})</p>
                        <p className="mb-0" style={{fontSize:'14px'}}>{formatCurrency(loanUsd * rate)}{getCurrencySymbol(user?.currency)}</p>
                    </div>
                    <div className="d-flex align-items-center justify-content-between">
                        <p className="mb-0 text-secondary" style={{fontSize:'14px'}}>Total Repayment</p>
                        <p className="mb-0" style={{fontSize:'14px'}}>{formatCurrency((loanUsd + (((ltv/convertToDays(period, duration) * lrate) / 100) * loanUsd)) * rate)}{getCurrencySymbol(user?.currency)}</p>
                    </div>
                    {disable === true ? (
                        <div
                            className="mt-2 myBtn rounded-pill px-3 py-2 fw-semibold text-center d-block disabled"
                            style={{ fontSize: '14px' }}
                        >
                            Get Loan <FontAwesomeIcon icon={faArrowUpRightFromSquare} style={{ fontSize: '12px' }} />
                        </div>
                        ) : (
                        ((Number(user?.credit_score) > 740)) ? (
                            <Link
                            to="/loansummary"
                            state={{
                                loan_id: loanID,
                                casset: casset,
                                collateral: collateral,
                                collat: collat,
                                loanasset: loanasset,
                                loan: loan,
                                loanUsd: loanUsd,
                                ltv: ltv,
                                cprice: cprice,
                                price: price,
                            }}
                            className="mt-2 myBtn rounded-pill px-3 py-2 fw-semibold text-center d-block"
                            style={{ fontSize: '14px' }}
                            >
                            Get Loan <FontAwesomeIcon icon={faArrowUpRightFromSquare} style={{ fontSize: '12px' }} />
                            </Link>
                        ) : (
                            <Link
                            to="/loandetails"
                            onClick={() => { 
                                localStorage.setItem('deposit.loanID', loanID);
                                localStorage.setItem('deposit.takeLoan', true);
                            }}
                            className="mt-2 myBtn rounded-pill px-3 py-2 fw-semibold text-center d-block"
                            style={{ fontSize: '14px' }}
                            >
                            Get Loan <FontAwesomeIcon icon={faArrowUpRightFromSquare} style={{ fontSize: '12px' }} />
                            </Link>
                        )
                    )}
                </div>
            </div>
        </div>
    )
}

export default LoanCalculator